import { Filter, filter as defaultFilter } from "./filter";

type CalendarElementType = "task" | "milestone" | "event" | "unavailability";

type CalendarScope = "PLANZONE" | "ZONE" | "PROJECT";

type CalendarFilter = Filter & {
  startDate: string;
  endDate: string;
  elementTypes?: CalendarElementType[];
  scope?: CalendarScope;
};

const calendarFilter: CalendarFilter = {
  ...defaultFilter,
  startDate: "",
  endDate: "",
};

export type { CalendarFilter, CalendarElementType, CalendarScope };

export { calendarFilter };
